export default [
  { path: '/absare17', redirect: '/campaign/absare17' },
  { path: '/accenturegp16', redirect: '/campaign/accenturegp16' },
  { path: '/barcbot19', redirect: '/campaign/barcbot19' },
  { path: '/barcbotsw17', redirect: '/campaign/barcbotsw17' },
  { path: '/barcghan17', redirect: '/campaign/barcghan17' },
  { path: '/barcghan19', redirect: '/campaign/barcghan19' },
  { path: '/barcseych17', redirect: '/campaign/barcseych17' },
  { path: '/barctanz17', redirect: '/campaign/barctanz17' },
  { path: '/barcug19', redirect: '/campaign/barcug19' },
  { path: '/barcuganda17', redirect: '/campaign/barcuganda17' },
  { path: '/barczim19', redirect: '/campaign/barczim19' },
  { path: '/bowmanslaw', redirect: '/campaign/bowmanslaw' },
  { path: '/cap2417', redirect: '/campaign/cap2417' },
  { path: '/capburs19', redirect: '/campaign/capburs19' },
  { path: '/capcar2419', redirect: '/campaign/capcar2419' },
  { path: '/capgdp18bus', redirect: '/campaign/capgdp18bus' },
  { path: '/capgdpex19', redirect: '/campaign/capgdpex19' },
  { path: '/capgum17', redirect: '/campaign/capgum17' },
  { path: '/caphrlink17', redirect: '/campaign/caphrlink17' },
  { path: '/caphrsu17', redirect: '/campaign/caphrsu17' },
  { path: '/capitec17', redirect: '/campaign/capitec17' },
  { path: '/capitechr17', redirect: '/campaign/capitechr17' },
  { path: '/capiteclink17', redirect: '/campaign/capiteclink17' },
  { path: '/capitecuct17', redirect: '/campaign/capitecuct17' },
  { path: '/capitecus17', redirect: '/campaign/capitecus17' },
  { path: '/capitecuwc17', redirect: '/campaign/capitecuwc17' },
  { path: '/caplink19', redirect: '/campaign/caplink19' },
  { path: '/capnep17', redirect: '/campaign/capnep17' },
  { path: '/capsiopsa17', redirect: '/campaign/capsiopsa17' },
  { path: '/casum17', redirect: '/campaign/casum17' },
  { path: '/hlovells18', redirect: '/campaign/hlovells18' },
  { path: '/mgp16', redirect: '/campaign/mgp16' },
  { path: '/mtngdp16', redirect: '/campaign/mtngdp16' },
  { path: '/mtngdp17', redirect: '/campaign/mtngdp17' },
  { path: '/mtngdp17cam', redirect: '/campaign/mtngdp17cam' },
  { path: '/mtngdp17dub', redirect: '/campaign/mtngdp17dub' },
  { path: '/mtngdp17gh', redirect: '/campaign/mtngdp17gh' },
  { path: '/mtngdp17ng', redirect: '/campaign/mtngdp17ng' },
  { path: '/mtngdp17papa', redirect: '/campaign/mtngdp17papa' },
  { path: '/mtngdp17rsa', redirect: '/campaign/mtngdp17rsa' },
  { path: '/mtngdp17sud', redirect: '/campaign/mtngdp17sud' },
  { path: '/mtngdp17swa', redirect: '/campaign/mtngdp17swa' },
  { path: '/mtngdp17ug', redirect: '/campaign/mtngdp17ug' },
  { path: '/mtngdp17zam', redirect: '/campaign/mtngdp17zam' },
  { path: '/nedbankgtp16', redirect: '/campaign/nedbankgtp16' },
  { path: '/nedbanklp16', redirect: '/campaign/nedbanklp16' },
  { path: '/nedbankquants16', redirect: '/campaign/nedbankquants16' },
  { path: '/nedbankrbb16', redirect: '/campaign/nedbankrbb16' },
  { path: '/nedbankrbbint16', redirect: '/campaign/nedbankrbbint16' },
  { path: '/nedbankrisk16', redirect: '/campaign/nedbankrisk16' },
  { path: '/nedbankwealth16', redirect: '/campaign/nedbankwealth16' },
  { path: '/nedcasum16', redirect: '/campaign/nedcasum16' },
  { path: '/nedsint17', redirect: '/campaign/nedsint17' },
  { path: '/nestle', redirect: '/campaign/nestle' },
  { path: '/omc2417', redirect: '/campaign/omc2417' },
  { path: '/omgap19', redirect: '/campaign/omgap19' },
  { path: '/omgapfb19', redirect: '/campaign/omgapfb19' },
  { path: '/omgaplink19', redirect: '/campaign/omgaplink19' },
  { path: '/omintra17', redirect: '/campaign/omintra17' },
  { path: '/omirec17', redirect: '/campaign/omirec17' },
  { path: '/omlink17', redirect: '/campaign/omlink17' },
  { path: '/perilink17', redirect: '/campaign/perilink17' },
  { path: '/periperi17', redirect: '/campaign/periperi17' },
  { path: '/rmbgdp19', redirect: '/campaign/rmbgdp19' },
  { path: '/sbcasaint16', redirect: '/campaign/sbcasaint16' },
  { path: '/sbcibclient16', redirect: '/campaign/sbcibclient16' },
  { path: '/sbcibfin16', redirect: '/campaign/sbcibfin16' },
  { path: '/sbcibfoi16', redirect: '/campaign/sbcibfoi16' },
  { path: '/sbcibglob16', redirect: '/campaign/sbcibglob16' },
  { path: '/sbcibgrit16', redirect: '/campaign/sbcibgrit16' },
  { path: '/sbcibint16', redirect: '/campaign/sbcibint16' },
  { path: '/sbcibinvest16', redirect: '/campaign/sbcibinvest16' },
  { path: '/sbcibit16', redirect: '/campaign/sbcibit16' },
  { path: '/sbcibitint16', redirect: '/campaign/sbcibitint16' },
  { path: '/sbcibrisk16', redirect: '/campaign/sbcibrisk16' },
  { path: '/sbcibtps16', redirect: '/campaign/sbcibtps16' },
  { path: '/sbcomp16', redirect: '/campaign/sbcomp16' },
  { path: '/sbgitint16', redirect: '/campaign/sbgitint16' },
  { path: '/sbior16', redirect: '/campaign/sbior16' },
  { path: '/sbiorint16', redirect: '/campaign/sbiorint16' },
  { path: '/sbpbb16', redirect: '/campaign/sbpbb16' },
  { path: '/sbpbbagri16', redirect: '/campaign/sbpbbagri16' },
  { path: '/sbpbbbus16', redirect: '/campaign/sbpbbbus16' },
  { path: '/sbpbbquants16', redirect: '/campaign/sbpbbquants16' },
  { path: '/sbpbbrisk16', redirect: '/campaign/sbpbbrisk16' },
  { path: '/sbpbbse16', redirect: '/campaign/sbpbbse16' },
  { path: '/sbquants16', redirect: '/campaign/sbquants16' },
  { path: '/sbtrust16', redirect: '/campaign/sbtrust16' },
  { path: '/standardbankca16', redirect: '/campaign/standardbankca16' },
  { path: '/stbmarketing', redirect: '/campaign/stbmarketing' },
  { path: '/webberwentzel17', redirect: '/campaign/webberwentzel17' },
  { path: '/werksmans17', redirect: '/campaign/werksmans17' },
]
